<div class="modal-dialog modal-lg">
  <div class="modal-content">
    <div class="modal-header">
      <div class="col-sm-6">
        <h5 class="modal-title" i18n>Edit Payment Schedule</h5>
      </div>
      <div class="col-sm-6 btn-holder text-right">
        <button (click)="onSave()" type="button" class="btn btn-success text-uppercase">
          <span class="fal fa-save"></span>
          <ng-container i18n>Save</ng-container>
        </button>
      </div>
      <a (click)="close()" class="cstm-close">
        <span class="fal fa-times"></span>
      </a>
    </div>
    <div class="modal-body">
      <form [formGroup]="termsForm">
        <div formArrayName="terms" *ngFor="let item of terms.controls; let i = index">
          <div [formGroupName]="i" class="row term-box">
            <div class="col-sm-1 remove-btn-box">
              <button
                matTooltip="Remove"
                i18n-matTooltip
                matTooltipClass="text-center"
                matTooltipPosition="above"
                (click)="onRemoveTerm(i)"
                type="button"
              >
                <i class="fal fa-minus"></i>
              </button>
            </div>
            <div *ngIf="hasDays(item['controls'].type.value)" class="col-sm-3">
              <mat-form-field class="mat-block">
                <input type="number" formControlName="days" matInput required placeholder="Days" i18n-placeholder />
              </mat-form-field>
            </div>
            <div class="col-sm-3">
              <mat-form-field class="mat-block">
                <input
                  type="text"
                  formControlName="typeView"
                  matInput
                  required
                  placeholder="Payment time"
                  i18n-placeholder
                />
              </mat-form-field>
            </div>
            <div class="col-sm-3">
              <mat-form-field class="mat-block">
                <input type="text" formControlName="percent" matInput required placeholder="Percent" i18n-placeholder />
              </mat-form-field>
            </div>
          </div>
        </div>
      </form>

      <form
        *ngIf="canAddMoreTypes(terms.controls) && remainingPercentage?.length > 0 && remainingTypes?.length > 0"
        [formGroup]="termForm"
        class="no-bottom no-top"
      >
        <div class="row">
          <div class="col-sm-1">
            <button (click)="onAddTerm()" type="button" class="btn btn-success text-uppercase action-btn" i18n>
              Add
            </button>
          </div>
          <div *ngIf="hasDays(termForm.get('type').value)" class="col-sm-3">
            <mat-form-field class="mat-block">
              <input type="number" formControlName="days" matInput required placeholder="Days" i18n-placeholder />
              <mat-error *ngIf="termForm.get('days').touched && termForm.get('days').hasError('required')" i18n>
                Days is required
              </mat-error>
              <mat-error *ngIf="termForm.get('days').touched && termForm.get('days').hasError('min')" i18n>
                Days must be positive number
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-sm-3">
            <mat-form-field>
              <mat-select
                matTooltip="Choose when the payment should be made"
                i18n-matTooltip
                matTooltipPosition="above"
                matTooltipClass="text-center"
                formControlName="type"
                placeholder="Payment time"
                i18n-placeholder
              >
                <mat-option *ngFor="let t of remainingTypes" [value]="t.value">
                  {{ t.label }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="termForm.get('type').touched && termForm.get('type').hasError('required')" i18n>
                Type is required
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-sm-3">
            <mat-form-field>
              <mat-select formControlName="percent" placeholder="Percent" i18n-placeholder>
                <mat-option *ngFor="let t of remainingPercentage" [value]="t"> {{ t }} % </mat-option>
              </mat-select>
              <mat-error *ngIf="termForm.get('percent').touched && termForm.get('percent').hasError('required')" i18n>
                Percent is required
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
